import request from '@/utils/request';

export const getSysConfig = () => request.get("/blade-wems/config/system/detail");

export const getSubSystem =() => request.get("/blade-wems/subsystem/list?size=1000&current=1");


export const loginByUsername = (options) => {
    return request({
        url: 'blade-auth/oauth/token',
        method: 'post',
        params: {
            ...options
        }
    })
}

export const checkUser =  (params) => request.post('/blade-auth/oauth/unlock?username=' + params.username + "&password=" +  params.password);

export const sys = () => request.get("/blade-wems/devicegroup/selectSys");

export const sysConfig = (params) => request.get("/blade-wems/devicegroup/selectAll?no=" + params);


export const refreshToken = (refresh_token, tenantId) => request({
    url: '/blade-auth/oauth/token',
    method: 'post',
    headers: {
        'Tenant-Id': tenantId
    },
    params: {
        tenantId,
        refresh_token,
        grant_type: "refresh_token",
        scope: "all",
    }
});

export const getHisList = (params) => request.get("/blade-wems/log/his/page", { params });

// export const emsStatus = (no) =>request.get("/blade-wems/ems/status?no="  + no);
export const emsStatus = (no) =>request.get("/blade-wems/ems/status/zip?no="  + no);


export const getHisUpdatetime = (no) =>request.get("/blade-wems/log/his/updatetime?no="  + no);

export const getRealPower = (no) =>request.get("/blade-wems/devicegroup/getRealPower?groupNo="  + no);

export const selectTop20 = (no) =>request.get("/blade-wems/devicealarm/selectTop20?groupNo="  + no);

export const rackBalance = (no) =>request.get("/blade-wems/devicegroup/rackBalance/zip?groupNo="  + no);

export const initUIP = (no) =>request.get("blade-wems/devicegroup/initUIP?groupNo="  + no);

export const getDuiModel = (no) =>request.get("blade-wems/devicegroup/getDuiModel?groupNo="  + no);

export const getTotalSOCAndStatus = (no) =>request.get("/blade-wems/devicegroup/getTotalSOCAndStatus?groupNo="  + no);

export const selectTop7 = (no) =>request.get("blade-wems/profitday/selectTop7?groupNo="  + no);

export const initDetailUIP = (groupNo) => request.get("/blade-wems/devicegroup/initDetailUIP?groupNo="+ groupNo);

export const getElc = (no) =>request.get("/blade-wems/powerGrid/data?no=" + no);

export const getGridEnergyCurrent = (groupNo) =>  request.get('/blade-wems/energyday/getGridEnergyCurrent?groupNo=' + groupNo);

export const getGridEnergyDetail = (params) =>  request.get('/blade-wems/energyday/getGridEnergyDetail', { params });

export const getLoadEnergyCurrent = (groupNo) =>  request.get('/blade-wems/energyday/getLoadEnergyCurrent?groupNo=' + groupNo);

export const getLoadEnergyDetail = (params) =>  request.get('/blade-wems/energyday/getLoadEnergyDetail', { params });

export const getCnEnergyCurrent = (groupNo) =>  request.get('/blade-wems/energyday/getCnEnergyCurrent?groupNo=' + groupNo);

export const getCnEnergyDetail = (params) =>  request.get('/blade-wems/energyday/getCnEnergyDetail', { params });

// export const getEnerday = (params) => request.get("blade-wems/energyday/selectByGroupNo", { params});
export const getEnerday = (params) => request.get("blade-wems/energyday/selectByGroupNo/zip", { params });

export const getElectricprice = (groupNo) => request.get("/blade-wems/electricprice/month/group?groupNo=" + groupNo);


export const getElectricPriceTemplates = (groupNo) => request.get("/blade-wems/electricprice/template/timeline/list?groupNo=" + groupNo);

export const saveOrUpdateTimeline = (params) =>  request.post("/blade-wems/electricprice/template/timeline/save", params);

export const removeTimelineTemp = (id) => request.post("/blade-wems/electricprice/template/timeline/remove?id=" + id);

export const getElectricPriceUnit = (groupNo) => request.get("/blade-wems/electricprice/template/unit/list?groupNo=" + groupNo);

export const saveOrUpdateUnit = (params) =>  request.post("/blade-wems/electricprice/template/unit/save", params);

export const removeTimelineUint = (id) => request.post("/blade-wems/electricprice/template/unit/remove?id=" + id);

export const getTempRelation = (groupNo) => request.get("/blade-wems/electricprice/template/relation/list?groupNo=" + groupNo);

export const saveTemplateRelation = (params) =>  request.post("/blade-wems/electricprice/template/relation/save", params);


export const getprofitdayList = (params) => request.get('/blade-wems/profitday/quantity/page', { params });

export const getprofitdayTotal = (params) => request.get('/blade-wems/profitday/quantity/total', { params });

export const getprofitdayFeeList = (params) => request.get("/blade-wems/profitday/fee/page", { params });

export const getprofitdayFeeTotal = (params) => request.get("/blade-wems/profitday/fee/total", { params });

export const getDatapowerHisDay = (params) => request.get('/blade-wems/datapower/history/day', {params});
export const getDatapowerHismonth = (params) => request.get('/blade-wems/datapower/history/month', {params});
export const getDatapowerHisyear = (params) => request.get('/blade-wems/datapower/history/year', {params});

export const saveSysConfig = (params) => request.post("/blade-wems/config/system/save", params);

export const getThreadMqttConfig = (params) => request.get("/blade-wems/config/getThreadMqttConfig", params);

export const updateThreadMqttConfig = (params) => request.post("/blade-wems/config/updateThreadMqttConfig", params);

export const getUserList  = (params) => request.get("/blade-wems/user/list", {params});

export const getRoleList  = () => request.get("/blade-wems/user/role/list");

export const addUser = (params) => request.post("/blade-wems/user/add", params);

export const removeUser = (userIds) => request.post("/blade-wems/user/delete?userIds=" + userIds);

export const updateUser =(params) => request.post("/blade-wems/user/edit", params);

export const updateUserPassword =(userId) => request.post("/blade-wems/user/resetPassword?userId=" + userId);

export const getUserDetails = (userId) => request.get("/blade-wems/user/detail?userId=" + userId);

export const updatePassword =(params) => request.post("/blade-wems/user/updatePassword?userId=" + params.userId + "&newPassword=" + params.newPassword + "&newPassword1=" + params.newPassword1 + "&oldPassword=" + params.oldPassword);

export const manaulLinkage = (params) => request.post("/blade-wems/ems/manaul/linkage/set", params);

export const getEnvStatus = () => request.get("/blade-wems/container/env/do/data");


export const exportGridEnergyDetail = (params) => request.get("/blade-wems/energyday/getGridEnergyDetail/export", { params , responseType: 'blob'});

export const exportCnEnergyDetail = (params) => request.get("/blade-wems/energyday/getCnEnergyDetail/export", { params, responseType: 'blob' });

export const exportLoadEnergyDetail = (params) => request.get("/blade-wems/energyday/getLoadEnergyDetail/export", { params,  responseType: 'blob'});

export const exportBmsPvEnergyDetail = (params) => request.get("/blade-wems/energyday/getBmsPvEnergyDetail/export", { params,  responseType: 'blob'});

export const exportQuantity = (params) => request.get("/blade-wems/profitday/quantity/export", { params , responseType: 'blob'});

export const exportFee = (params) => request.get("/blade-wems/profitday/fee/export", { params, responseType: 'blob' });

export const exportLog = (params) => request.get("/blade-wems/log/his/export", { params, responseType: 'blob' });


export const getBmsUsageUsingGET = (groupNo) => request.get("/blade-wems/profitday/bms/usage?groupNo=" + groupNo);


export const getGuardData = (groupNo) => request.get("/blade-wems/profitday/bms/usage/zip?groupNo=" + groupNo);

export const getGuardChartData = (params) => request.get("/blade-wems/profitday//fee/profit/zip", { params });



export const getPVState = (no) => request.get("/blade-wems/pv/control/manual/state?no=" + no);

export const setPVState = (params) => request.post("/blade-wems/pv/control/manaul/param/pvenable/set", params);

export const setPVrunState = (params) => request.post("/blade-wems/pv/control/manual/run/set", params);

export const setPVpower = (params) => request.post("/blade-wems/pv/control/manaul/param/power/set", params);

export const getRunStatus = (groupNo) => request.get("/blade-wems/devicegroup/runStatus?groupNo=" + groupNo);

export const getVersions  = () => request.get("/blade-wems/config/version");

export const getSubsystems  = (params) => request.get("/blade-wems/subsystem/list", params);

export const airCard = () => request.get("/blade-wems/container/env/lifun/ac/data");



export const getDbBackupSatus = () => request.get('/blade-wems/dbBackup/isRunning');

export const startBbBackup = () => request.post('/blade-wems/dbBackup/start');

export const cancelBbBackup = () => request.post('/blade-wems/dbBackup/cancel');

export const getDbBackup = () => request.get('/blade-wems/dbBackup/info');

export const SetQinganState = (state, index) => request.post('/blade-wems/ems/qingan/bms/state/set?state='+ state + "&index=" + index);

export const GetQinganState = () => request.get('/blade-wems/ems/qingan/bms/state/get');

export const GetThresholdVis = () => request.get("/blade-wems/deviceThreshold/isShow");

export const GetThreshold = ( params ) => request.get("/blade-wems/deviceThreshold/page", { params });

export const GetThresholdValue = ( params ) => request.get("/blade-wems/deviceThreshold/value/get", { params });

export const SetThresholdValue = ( params ) => request.post("/blade-wems/deviceThreshold/value/set", params);

export const GetDeviceByDeviceGroup = ( params ) => request.get("/blade-wems/device/getDeviceGroupByDeviceType");

export const GetDeviceField = ( params ) => request.get("/blade-wems/dataexportconfig/getTitles", { params });

export const GetDeviceData = ( params ) => request.get("/blade-wems/devicedata/page", { params });

export const GetDeviceDataDownload = ( params ) => request.get("/blade-wems/devicedata/export", { params , responseType: 'blob',  timeout:3600000 });

export const GetDeviceExportConfig = (params) => request.get("/blade-wems/dataexportconfig/getForDisplay", { params });

export const setDeviceDisplay = (params) => request.post("/blade-wems/dataexportconfig/setDisplay", params);

export const getDeviceConfigTagById = (id) => request.get("/blade-wems/dataexportconfig/detail?id=" +  id);

export const updateDeviceConfig = (params) => request.post("/blade-wems/dataexportconfig/update", params);

export const getTagListDict = (tagNo) => request.get("/blade-wems/tagdict/list?tagNo=" +  tagNo);

export const addTagListDict = (params) => request.post("/blade-wems/tagdict/save", params);

export const removeTagListDict = (ids) => request.post("/blade-wems/tagdict/remove?ids=" + ids);

export const getWeChatList = (params) => request.get("/blade-wems/alarm/im/group/list", { params });

export const addWeChat = (params) => request.post("/blade-wems/alarm/im/group/submit", params);


export const removeWeChat = (id) => request.post("/blade-wems/alarm/im/group/remove?id=" + id);

export const getAlarmLevelList = () => request.get("/blade-wems/alarm/im/level/list");

export const removeAlarmLevel = (id) => request.post("/blade-wems/alarm/im/level/remove?id=" + id);

export const submitAlarmLevel = (params) => request.post("/blade-wems/alarm/im/level/submit", params);

export const getUnselectedList = (params) => request.get("/blade-wems/alarm/im/unselected/list", {params});

export const getSelectedList = (params) => request.get("/blade-wems/alarm/im/selected/list", {params});

export const setRelation = (params) => request.post("/blade-wems/alarm/im/group/relation/set", params);

export const editRelation = (params) => request.post("/blade-wems/alarm/im/group/relation/edit", params);


export const getUseAlarmList = () => request.get("/blade-wems/alarm/im/level/use/list");

export const getGFEnergyCurrent = (groupNo) => request.get("/blade-wems/energyday/getBmsPvEnergyCurrent?groupNo=" + groupNo);

export const getGFEnergyDetail = (params) =>  request.get('/blade-wems/energyday/getBmsPvEnergyDetail', { params });

export const getContainerPic = () => request.get("/blade-wems/container/pic/get");

export const setContainerPic = (params) => request.post("/blade-wems/container/pic/set", params);


export const getStationMoinfo = () => request.get("/blade-wems/station/more/info/get");

export const setStationMoinfo = (params) => request.post("/blade-wems/station/more/info/set", params);

export const getCh4 = () => request.get("/blade-wems/container/get/ch4/threshold");

export const setCh4 = (ch4) => request.post("/blade-wems/container/set/ch4/threshold?ch4=" + ch4);

export const getTagPage = (params) => request.get("/blade-wems/tagtemplate/page", { params });

export const romoveTagtemplate = (ids) => request.post("/blade-wems/tagtemplate/remove?ids=" + ids);

export const addTag = (params) => request.post("/blade-wems/tagtemplate/save", params);

export const editTag = (params) => request.post("/blade-wems/tagtemplate/update", params);

export const getTagAlarm = (tagNo) => request.get('/blade-wems/tagalarm/list/data?tagNo=' + tagNo);

export const  submitTagalarm = (params) => request.post("/blade-wems/tagalarm/batch/submit", params);

export const TagDownload = ( params ) => request.get("/blade-wems/tagtemplate/export", { params , responseType: 'blob',  timeout:3600000 });

export const getRealDataByDevice = (params) => request.get("/blade-wems/devicedata/realData",  { params });

export const clearcache= () => request.post("/blade-wems/config/clearData");

export const getChargeHis = (params) =>  request.get("/blade-wems/charge/his/gaoyue344/detail", { params });

export const getEnvTemplateList = (params) =>  request.get("/blade-wems/env/template/list", { params });

export const saveEnvTemp  = (params) => request.post("/blade-wems/env/template/save", params);

export const deleteTemp = (id) => request.post("/blade-wems/env/template/delete?id=" +  id);

export const copyTemp = (id) => request.post("/blade-wems/env/template/clone?id=" +  id);

export const TempDownload = ( params ) => request.get("/blade-wems/env/template/export", { params , responseType: 'blob',  timeout:3600000 });

export const getTaskDownList = ( params ) => request.get("/blade-wems/task/page", { params });

export const getPCSprofitdayList = (params) => request.get('/blade-wems/profitday/pcs/quantity/page', { params });

export const getPCSprofitdayTotal = (params) => request.get('/blade-wems/profitday/pcs/quantity/total', { params });

export const exportPCSFee = (params) => request.get("/blade-wems/profitday/pcs/quantity/export", { params, responseType: 'blob' });

export const getEnvBindDevices = (envId) => request.get("/blade-wems/env/template/device/select?envId=" + envId);

export const getEnvunBindDevices = (envId) => request.get("/blade-wems/env/template/device/unselect?envId=" + envId);

export const doEnvBindDevices = (params) => request.post("/blade-wems/env/template/device/save", params);

export const getEnvTemps = (params) =>  request.get("/blade-wems/env/device/template", { params });

export const getEnvDevices = (params) =>  request.get("/blade-wems/env/data/byTemplate", { params });

export const sendControl = (params) => request.post("/blade-wems/env/device/control", params);

export const getSysSetList = (params) => request.get("/blade-wems/config/getList", {params});

export const updateSysSet = (params) => request.post("/blade-wems/config/update", params);

export const subsystemUpdate = (params) => request.post("/blade-wems/subsystem/update", params);

export const getContainerList = (params) => request.get("/blade-wems/container/list", { params });

export const containerUpdate= (params) => request.post("/blade-wems/container/submit",  params );

export const removeContainer = (id) => request.post("/blade-wems/container/remove?ids=" +  id);

export const getDeviceManagementList = (params) => request.get("/blade-wems/deviceManagement/device/list", { params });

export const getGatewayAndContainerList = (params) => request.get("/blade-wems/deviceManagement/gatewayAndContainerList", { params });

export const getDeviceType = (params) =>  request.get("/blade-wems/deviceManagement/deviceTypeList", { params });

export const updateBind = (params) => request.post("/blade-wems/deviceManagement/updateContainer", params);

export const saveOrUpdataDevice = (params) => request.post("/blade-wems/deviceManagement/device/save", params);

export const deleteDevice = (deviceId) => request.post("/blade-wems/deviceManagement/device/delete?deviceId=" + deviceId);

export const updataUpDevice = (params) =>  request.post("/blade-wems/deviceManagement/device/batch/update/upDevice", params);

export const updateDeviceSys = (params) =>  request.post("/blade-wems/deviceManagement/device/batch/update/subSystem", params);

export const updateDeviceExdInfo = (params) =>  request.post("/blade-wems/deviceManagement/device/batch/update/exdInfo", params);

export const checkDevicerigth = () => request.post("/blade-wems/deviceManagement/device/bms/relation/check");

export const updateDeviceDui = (params) => request.post("/blade-wems/deviceManagement/device/bms/clusterParam/update", params);

export const updateDeviceGoup = (params) => request.post("/blade-wems/deviceManagement/device/bindGroup/update", params);

export const systemActivationDate = (date) => request.post("/blade-wems/config/update/systemActivationDate?date=" + date);

// 设备数据检测
export const deviceDataCheck = (params) => request.get("/blade-wems/deviceManagement/device/data/check", { params });

export const deleteDevicePacth = (deviceIds) => request.post("/blade-wems/deviceManagement/device/batch/delete?deviceIds=" + deviceIds);

export const exportDevices = (params) => request.post("/blade-wems/deviceManagement/device/export", params, { responseType: 'blob',  timeout:3600000 });

export const getEmsctrlAlarm = () => request.get("/blade-wems/devicealarm/getEmsctrl");

export const restartOpenapi = () => request.get("/blade-wems/config/restartOpenapi");

export const getNodeConfig = () => request.get("/blade-wems/multi-device-support/getNodeConfig");

export const setNodeConfig = (params) => request.post("/blade-wems/multi-device-support/setNodeConfig", params);

export const getUpgradebList = (params) =>request.get("/blade-wems/upgrade/list", { params });

export const startUpgrade = (params) => request.post("/blade-wems/upgrade/start", params);

export const stopUpgrade = (id) => request.post("blade-wems/upgrade/stop?id=" + id);





